import { css } from 'lit';

export const homeSignedInViewStyles = css`
  
  :host {
    background: linear-gradient(
      180deg,
      var(--teal-5) 0%,
      var(--teal-1) 200px,
      var(--gray-1) 300px
    );
  }

  view-content {
    z-index: 2;
    position: relative;
    padding-top: 6rem;
  }

  header-bar {
    border-bottom-color: white !important;
    padding-bottom: 1rem;
  }

  button-bar .timestamp {
    font-size: 0.9rem;
    font-style: italic;
    color: var(--teal-7);
    font-weight: 300;
  }

  sl-divider {
    --color: white;
  }

  /*=== MEMBERSHIPS SECTION ===*/

  #your-memberships {
    display: block;
  }

  #your-memberships > .subsection {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    gap: 1rem;
  }
  #your-memberships > .subsection:not(:last-child) {
    margin-bottom: 2.5rem;
  }

  #your-memberships > .subsection > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    grid-column: span 1;
  }
  #your-memberships > .subsection > .item {
    grid-column: span 1;
  }
  #your-memberships > .subsection > .item.empty {
    color: var(--gray-6);
    font-style: italic;
    font-weight: 200;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
  }
  #your-memberships > .subsection > .item.empty sl-icon {
    margin-right: 0.5rem;
  }
  #your-memberships > .subsection > .header > h2 {
    margin: 0;
    font-size: 1rem;
    line-height: 1.3em;
    font-weight: 400;
    color: var(--teal-7);
    font-style: italic;
  }
  
  /*=== INBOX SECTION ===*/

  #your-inbox {
    background: white;
    border: 1px solid var(--gray-2);
    border-radius: 7px;
  
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    gap: 1rem;
    padding: 1rem;
  }
  #your-inbox > .item {
    grid-column: span 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }
  #your-inbox > .item.empty {
    color: var(--gray-6);
    font-style: italic;
    font-weight: 200;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
  }
  #your-inbox > .item > sl-icon {
    color: var(--teal-7);
  }

  /*=== INFO CARDS ===*/

  #info-cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
    gap: 1rem;
  }

  #info-cards > .item {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    
    background: var(--teal-0);
    padding: 2rem;
    gap: 1rem;
    border-radius: 7px;
    border: 1px solid var(--teal-2);
  }

  #info-cards > .item > h3 {
    color: var(--teal-8);
    font-weight: 400;
    margin: 0;
  }
  #info-cards > .item > p {
    flex: 1 1 auto;
  }

`;
